import React, { useEffect, useRef } from "react";
import topSvg from "../../../assets/svg/top.svg";
import bottomSvg from "../../../assets/svg/bottom.svg";
import mainLogoSvg from "../../../assets/img/Main logo.png";
import { Form, Input, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux"; 
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast"; 
import svg41 from "../../../assets/svg/svg41.svg";
import { resetPassword } from "../../../features/auth/authSlice";

function EmailForm() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const { authLoading ,saving} = useSelector((state) => state.auth);

  const onFinish = async (data) => {
    const res = await dispatch(
      resetPassword({ 
        ...data,
        url: `auth/forgot-password`,
      })
    );
 
    if (res?.payload?.success) {
      toast.success(res.payload?.message);
      await navigate("/verify-forgot-email");
    } else {
      toast.error(res.payload?.message);
    }
  };


  const handleCancel = async () => {
    await navigate("/login");
  };

  return (
    <div className="w-full h-full min-h-screen flex flex-col op-bg">
      <div>
        <img src={topSvg} alt="topSvg" />
      </div>
      <div className="w-full flex flex-col h-full lg:px-0 px-3 lg:items-center lg:justify-center ">
        <div className="login-card lg:p-[2.5rem] p-3">
          <div>
            <img
              src={mainLogoSvg}
              alt="mainLogoSvg"
              className="cursor-pointer"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="typography_1 mt-[2.5rem]">Forgot Password</div>
          <div className="typography_2">Enter your associated email.</div>
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="lg:w-[34.25rem] w-full"
            style={{
              maxWidth: "100%",
              marginTop: "2.06rem",
            }}
            form={form}
          >
            <Form.Item
              name="email"
              label={"Email"}
              rules={[
                {
                  required: true,
                  message: "Please add email address",
                },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
              ]}
            >
              <Input type="email" className="input" />
            </Form.Item>

            <div className="flex justify-center w-full mt-[1rem]">
              <button
                className="cstm-btn-2"
                type="submit"
                disabled={saving ? true : false}
              >
                {saving ? <Spin /> : "Next"}
              </button>
            </div>

            <div className="flex justify-between mt-[1rem]">
              <div
                className="flex items-center gap-x-[1rem] cursor-pointer"
                onClick={handleCancel}
              >
                <img src={svg41} alt="svg41" />
                <span className="back">Back to login</span>
              </div>
              <Link className="forgot-text !text-[#0092CC]">Help</Link>
            </div>
          </Form>
        </div>
      </div>
      <div className="w-full  mt-auto flex items-center justify-center bottom-0">
        <img src={bottomSvg} alt="bottomSvg" />
      </div>
    </div>
  );
}

export default EmailForm;
